<template lang="html">
  <form action="#">
    <div class="form-group custom-check">
      <div v-html="question.title" class="col-form-label pt-0 form-group title-textbox" style="padding-bottom: 0.50rem; text-align: justify;"></div>
      <b-form-group>  
        <b-form-checkbox-group id="checkboxes1" name="options" v-model="question.options_values" :options="options_formatted" v-if="options_formatted.length < 6" class="paddingCheck">
        </b-form-checkbox-group>
        <b-form-checkbox-group id="checkboxes2" name="options" v-model="question.options_values" v-else>
        <b-row>
          <b-col v-for="item in options_formatted" :key ="item.key" sm="12" md="6" >
            <b-form-checkbox :value="item.value" class="padding-check-divider"><span>{{item.text}}</span></b-form-checkbox>
          </b-col>
        </b-row>
        </b-form-checkbox-group>
      </b-form-group>
    </div>
  </form>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';

export default {
  props: {
    question: {
      type: Object,
      required: true
    },
    prevId: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      selected: '',
      question_id: false,
      options_formatted: [],
      prev_question_id: false
    };
  },
  computed: {
  },
  watch: {
    question (val) {
      this.options_formatted = [];
      const options = this.question.options;
      for (let i = 0; i < options.length; i++) {
        const option = options[i];
        this.options_formatted.push({
          value: option.id,
          text: option.title
        });
      }
    }
  },
  mounted () {
    const options = this.question.options;
    for (let i = 0; i < options.length; i++) {
      const option = options[i];
      this.options_formatted.push({
        value: option.id,
        text: option.title
      });
    }
    if (this.question.value) {
      this.selected = this.question.value;
    }
  },
  methods: {
  }
};
</script>

<style lang="css">
  .custom-check .col-form-label{
    font-size: 20px;
    font-weight: bold;
    padding-left: 4px;
    margin-left: 8px;
  }
  .custom-check .custom-control-label{
    font-size: 18px;
    font-weight: 300;
    margin-left: 5px;
  }
  .custom-check .custom-control-label::before {
    width: 1.2rem;
    height: 1.2rem;
  }
  .custom-check .custom-control-label::after {
    background-size: 90%;
  }
  .custom-check .custom-control {
      width: 100%;
      display: block;
    }
  .custom-check .custom-control + .custom-control{
    margin-top: 8px;
  }
  .custom-check .custom-control .custom-control-label {
    display: block;
    margin: 0 auto;
    text-align: left;
  }
  .paddingCheck{
    padding: 0px 1px 5px 30px;
  }
  .padding-check-divider{
    padding: 0px 1px 5px 15px;
  }
  .custom-check .custom-checkbox .custom-control-input:checked~.custom-control-label:after{
    padding: 8px;
  }
  @media screen and (max-width: 768px){
    .custom-check .custom-control-label{
      font-size: 16px;
      font-weight: 300;
      margin-left: 5px;
    }
    
  }
  @media only screen and (orientation: portrait) and (max-width: 475px)  {
    .paddingCheck{
      padding: 0px 10px 0px 10px;
    }
    .padding-check-divider{
      padding: 0px 1px 7px 30px;
    }
    .custom-check .custom-control-label{
      font-size: 14px;
      font-weight: 300;
      margin-left: 5px;
    }
    .custom-check .col-form-label{
      font-size: 16px;
      font-weight: bold;
    }
    .custom-check .form-group{
      margin-bottom: 0px;
    }
  } 
</style>



// WEBPACK FOOTER //
// src/surveys/components/Check.vue